const API_BASE =
  process.env.REACT_APP_API_URL || "https://apimukemel.com/api/index.php";

const normalizeLang = (lang = "en") => lang.split("-")[0].toLowerCase();

const getEndpointForLang = (lang = "en") => {
  const l = normalizeLang(lang);

  // API tarafında:
  // en -> /products
  // tr -> /products-tr
  // ar -> /products-ar
  if (l === "tr" || l === "ar") {
    return `${API_BASE}/products-${l}`;
  }
  return `${API_BASE}/products`;
};

const fetchProductsForLang = async (lang = "en") => {
  const url = getEndpointForLang(lang);
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Ürünler (${lang}) endpoint'ine ulaşılamadı: ${url}`);
  }

  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

// ---------------------------------------------------------------------------
// Önceden /public/products/{lang}.json'dan okuyordu, artık API'den okuyor
// ---------------------------------------------------------------------------
export const loadProductsByLang = async (lang = "tr") => {
  const baseLang = normalizeLang(lang);
  return fetchProductsForLang(baseLang);
};

// ---------------------------------------------------------------------------
// EN ürünlerini baz alıp, seçili dile (tr/ar) göre override eden yapı
// (en + localized merge) – önceki mantığın API versiyonu
// ---------------------------------------------------------------------------
export const loadValidProducts = async (lang = "en") => {
  const baseLang = normalizeLang(lang);

  // Her zaman en'i çek
  const enProducts = await fetchProductsForLang("en");

  // Eğer istenen dil ingilizceyse direkt dön
  if (baseLang === "en") return enProducts;

  // TR veya AR ise ilgili endpoint'ten ürünleri çek
  let localizedProducts = [];
  try {
    localizedProducts = await fetchProductsForLang(baseLang);
  } catch (e) {
    console.error(`Localized ürünler (${baseLang}) alınamadı:`, e);
    return enProducts;
  }

  const localizedMap = new Map(
    localizedProducts.map((p) => [p.stock_code || p.id, p])
  );

  // EN ürününe karşılık gelen localized varsa üstüne yaz
  return enProducts.map((p) => {
    const key = p.stock_code || p.id;
    const localized = localizedMap.get(key);
    return localized ? { ...p, ...localized } : p;
  });
};

// ---------------------------------------------------------------------------
// EN (API) ürünü varsa göster, TR/AR varsa çevir (CategoryDetailPage burada)
// ---------------------------------------------------------------------------
export const loadProductsWithLangFallback = async (lang = "en") => {
  const baseLang = normalizeLang(lang);

  // Önce her zaman EN ürünlerini çek
  const enProducts = await fetchProductsForLang("en");

  // İngilizce ise ek işleme gerek yok
  if (baseLang === "en") return enProducts;

  try {
    const localizedProducts = await fetchProductsForLang(baseLang);
    const localizedMap = new Map(
      localizedProducts.map((p) => [p.stock_code || p.id, p])
    );

    return enProducts.map((p) => {
      const key = p.stock_code || p.id;
      const localized = localizedMap.get(key);
      return localized ? { ...p, ...localized } : p;
    });
  } catch (e) {
    console.error(
      `loadProductsWithLangFallback: ${baseLang} verisi alınamadı, EN'e düşüldü`,
      e
    );
    return enProducts;
  }
};

// ---------------------------------------------------------------------------
// Sepetteki ürünleri TR/AR API’den çekilen verilerle lokalize etme
// ---------------------------------------------------------------------------
export const localizeCartItems = async (cartItems, lang = "en") => {
  const baseLang = normalizeLang(lang);

  // Sepeti İngilizce kullanıyorsak ekstra işleme gerek yok
  if (baseLang === "en") return cartItems;

  try {
    const localizedProducts = await fetchProductsForLang(baseLang);
    const localizedMap = new Map(
      localizedProducts.map((p) => [p.stock_code || p.id, p])
    );

    return cartItems.map((item) => {
      const key = item.stock_code || item.id;
      const localized = localizedMap.get(key);
      return localized ? { ...item, ...localized } : item;
    });
  } catch (e) {
    console.error("localizeCartItems hata:", e);
    return cartItems;
  }
};
